import type { CityConfig } from "@/pages/city-template/types";

export const redHookConfig: CityConfig = {
  city: "Red Hook",
  state: "New York",
  stateAbbr: "NY",
  slug: "red-hook",
  route: "/cities/red-hook",
  title: "Emergency & Expedited Passport Red Hook NY | Same Day Passport Red Hook",
  metaDescription:
    "Emergency passport Red Hook NY — same day, 24-hour, and 3-5 day expedited passport processing for Dutchess County. Fast Passport Center serves Red Hook, Rhinebeck, Tivoli, and all rural Hudson Valley communities.",
  h1: "Emergency & Expedited Passport Services in Red Hook, NY",
  heroSubtitle:
    "Red Hook's fast passport solution — from rural Dutchess County farmland to the Hudson Valley. Whether you're flying out of Stewart International or Albany, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Rural%20farmland%20and%20countryside%20of%20Red%20Hook%20New%20York%20in%20Dutchess%20County%2C%20beautiful%20Hudson%20Valley%20landscape%20with%20rolling%20agricultural%20fields%2C%20distant%20Berkshire%20Mountains%2C%20historic%20barns%20and%20farmhouses%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20warm%20earth%20tones%2C%20no%20text%20overlay%2C%20scenic%20rural%20Hudson%20Valley%20farmland%20scene%20with%20hills%20and%20mountains%20in%20distance&width=1600&height=700&seq=ny-red-hook-hero-001&orientation=landscape",
  heroImageAlt: "Rural Red Hook farmland in Dutchess County with Hudson Valley landscape and Berkshire Mountains",
  geoPosition: "42.0209; -73.8754",
  geoPlacename: "Red Hook, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~95 miles (South in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Red Hook", zips: "12571" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Tivoli", zips: "12583" },
    { name: "Barrytown", zips: "12507" },
    { name: "Annandale-on-Hudson", zips: "12504" },
    { name: "Germantown", zips: "12526" },
    { name: "Livingston", zips: "12541" },
    { name: "Milan", zips: "12571" },
    { name: "Pine Plains", zips: "12567" },
    { name: "Ancram", zips: "12502" },
    { name: "Copake", zips: "12516" },
    { name: "Gallatin", zips: "12567" },
    { name: "Hyde Park", zips: "12538" },
    { name: "Kingston", zips: "12401, 12402" },
    { name: "Poughkeepsie", zips: "12601, 12602, 12603" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Red Hook travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Red Hook residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Rural Dutchess County",
      desc: "Red Hook, Rhinebeck, Tivoli, and the entire rural Hudson Valley — we serve all of northern Dutchess County.",
    },
  ],
  testimonials: [
    {
      name: "Sarah W.",
      location: "Red Hook, NY",
      rating: 5,
      text: "Running a farm here means I can't just drop everything. Fast Passport Center handled my passport renewal entirely remotely. The 5-day service was perfect — had it back in time for my trip to Ireland.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas B.",
      location: "Annandale-on-Hudson, NY",
      rating: 5,
      text: "Needed an emergency passport for a conference in London in 4 days. Fast Passport Center got it done in 3. The agent even called me to confirm everything was correct before submission.",
      service: "Emergency Passport",
    },
    {
      name: "Laura M.",
      location: "Tivoli, NY",
      rating: 5,
      text: "First-time passport for my whole family — we were all applying at once. Fast Passport Center coordinated all four applications and had them processed in 5 days. Outstanding service for a busy family.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "red-hook-1",
      name: "Red Hook Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "7460 South Broadway",
      city: "Red Hook",
      state: "NY",
      zip: "12571",
      phone: "845-758-8941",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown Red Hook",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Red Hook passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "red-hook-2",
      name: "Rhinebeck Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "6387 Mill Street",
      city: "Rhinebeck",
      state: "NY",
      zip: "12572",
      phone: "845-876-4031",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Rhinebeck (~5 miles south)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Convenient for Rhinebeck and south Red Hook residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "red-hook-3",
      name: "Tivoli Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "73 Broadway",
      city: "Tivoli",
      state: "NY",
      zip: "12583",
      phone: "845-757-2301",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Tivoli (~8 miles north)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Tivoli, Barrytown, and north Red Hook communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Red Hook?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Red Hook residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Red Hook?",
      a: "The Red Hook Post Office at 7460 South Broadway is the main Red Hook passport acceptance facility. The Rhinebeck Post Office at 6387 Mill Street and Tivoli Post Office at 73 Broadway are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Red Hook?",
      a: "Yes — passport photos are available at CVS Pharmacy and Rite Aid locations in Red Hook, Rhinebeck, and nearby Dutchess County towns. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Red Hook?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Red Hook passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Red Hook?",
      a: "The fastest way to renew a passport in Red Hook is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Red Hook?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Red Hook and all Dutchess County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Red Hook?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Red Hook. We serve rural Dutchess County and all of the Hudson Valley through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Red Hook", address: "various CVS locations in Red Hook, Rhinebeck, and nearby Dutchess County towns", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Poughkeepsie", address: "various Walgreens locations in Poughkeepsie and Wappingers Falls", hours: "Mon-Sun, hours vary by location" },
    { name: "Rite Aid — Red Hook", address: "Rite Aid locations in Red Hook and Rhinebeck", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Poughkeepsie", address: "various UPS Store locations in Poughkeepsie", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Poughkeepsie", address: "various FedEx Office locations in Poughkeepsie", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Poughkeepsie",
      address: "22 Mansion Street, Poughkeepsie, NY 12601",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Poughkeepsie DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Newburgh",
      address: "2 Lake Street, Newburgh, NY 12550",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Newburgh DMV office serving western Dutchess County and Orange County residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Wappingers Falls",
      address: "29 Marshall Road, Wappingers Falls, NY 12590",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Wappingers Falls DMV office serving south Dutchess County and Hudson Valley corridor.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "~30 miles from Red Hook",
      address: "1180 First Street, New Windsor, NY 12553",
      note: "Stewart International is the closest major airport to Red Hook with flights to major U.S. hubs including Orlando, Las Vegas, and seasonal European destinations. Perfect for rural Dutchess County travelers.",
      flightUrl: "https://www.swfny.com/",
      flightLabel: "Stewart Airport",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~70 miles from Red Hook",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Albany International is the major upstate airport with flights to major U.S. and international destinations. Alternative for Red Hook area travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~90 miles from Red Hook",
      address: "JFK Airport, Queens, NY 11430",
      note: "Major international airport with flights to every continent. Alternative for Red Hook area travelers needing international connections.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Red Hook travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Red Hook residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Red Hook residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Red Hook residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Red Hook, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Red Hook residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Red Hook travelers with immediate departure needs from Stewart International or Albany." },
    { name: "Passport Renewal", description: "Fast passport renewal for Red Hook residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Red Hook residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Red Hook residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Red Hook and Dutchess County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Red Hook." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Red Hook travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Red Hook travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Red Hook team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Red Hook address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "New Paltz", route: "/cities/new-paltz" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "Beacon", route: "/cities/beacon" },
    { name: "Fishkill", route: "/cities/fishkill" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Tarrytown", route: "/cities/tarrytown" },
    { name: "Rhinebeck", route: "/cities/rhinebeck" },
    { name: "Hyde Park", route: "/cities/hyde-park" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Red Hook and all of rural Dutchess County as a remote courier service. We do not have a physical office in Red Hook, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Red Hook area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Red Hook and all of rural Dutchess County. From the rolling farmland to the Hudson River, from Rhinebeck to Tivoli — we serve the entire Red Hook region with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Red Hook and all surrounding communities across northern Dutchess County and the Hudson Valley. Whether you're in Rhinebeck, Tivoli, or Annandale-on-Hudson, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Red Hook customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Red Hook travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Red Hook travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Red Hook. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default redHookConfig;